import * as React from "react";
import { Route, Switch } from "react-router-dom";
import Summary from "./Settlements.Summary";
import Batches from "./Settlements.Batches";
import BankSettlements from "./Settlements.BankSettlements";
import WithdrawalBatches from "./Settlements.WithdrawalBatches";

const Settlements = props => (
  <Switch>
    <Route
      exact={true}
      path="/snapscan/settlements/summary"
      render={() => <Summary {...props} />}
    />
    <Route
      path="/snapscan/settlements/batches"
      render={() => <Batches {...props} />}
    />
    <Route
      path="/snapscan/settlements/bank_settlements"
      render={() => <BankSettlements {...props} />}
    />
    <Route
      path="/snapscan/settlements/withdrawals/batches"
      render={() => <WithdrawalBatches {...props} />}
    />
  </Switch>
);

export default Settlements;
